module.exports = __webpack_public_path__ + "img/open-feedback.c6675769.png";